import React, {Component} from "react";
import * as designerActions from "../../redux/actions/designer";
import {FlatList, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View,} from "react-native";
import {bindActionCreators} from "redux";
import goTo, {goBack} from "../../utils/goTo";
import {connect} from "react-redux";
import Icon from "react-native-vector-icons/FontAwesome";
import {errorColors, RepositColours} from "../../utils/styles";
import WebHeading from "../../components/WebHeading";
import {browserHistory} from "react-router";
import {BatteryIllustration, InverterIllustration, SolarIllustration,} from "./ComponentIllustrations";

const styles = StyleSheet.create({
  listItem: {
    maxWidth: 400,
    minWidth: 350,
    height: 110,
    borderBottomColor: "#E2E2E2",
    borderBottomWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  bodyTextContainer: {
    flex: 1,
    alignItems: "center",
  },
  wrapper: {
    backgroundColor: "white",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
  },
  bodyText: {
    marginVertical: 10,
  },
  stepBox: {
    flexDirection: "row",
    marginBottom: 50,
    marginHorizontal: 50,
  },
  addressBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 10,
  },
});

const ComponentItem = ({ title, description, error, image, onSelect }) => {
  return (
    <TouchableOpacity style={styles.listItem} onPress={onSelect}>
      {/*<Text style={{flex: 1, textAlign: "center"}}>Image</Text>*/}
      <View>{image}</View>
      <View style={{ ...styles.buttonText, flex: 1, paddingHorizontal: 20 }}>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text style={{ color: RepositColours.lightGrey }}>{title}</Text>
          <Text
            style={{ color: onSelect ? "black" : RepositColours.lightGrey }}
          >
            {description}
          </Text>
          <Text style={{ color: errorColors.orange }}>{error}</Text>
        </View>
      </View>
      {onSelect ? (
        <Icon
          name={error ? "exclamation-circle" : "chevron-right"}
          size={18}
          color={error ? errorColors.orange : RepositColours.lightGrey}
        />
      ) : null}
    </TouchableOpacity>
  );
};

const mapStateToProps = (state) => ({
  inverterSystems: state.designer.kit.design.inverterSystems,
  inverterTypes: state.designer.constraints.inverterTypes,
  batteryTypes: state.designer.constraints.batteryTypes,
  context: state.designer.kit.context,
});

const mapDispatchToProps = (dispatch) => {
  return {
    designerActions: bindActionCreators(designerActions, dispatch),
  };
};

export class ComponentList extends Component {
  static navigationOptions = ({ navigation }) => {
    return {
      headerMode: "none",
    };
  };

  handleComponentSelected = (component) => {
    this.props.designerActions.openComponent(component);
    goTo(this.props.navigation, "ComponentSelection");
  };

  getPhasesDescription = (numPhases) => {
    switch (numPhases) {
      case 1:
        return "Single phase";
      case 3:
        return "Three phase";
      default:
        return "Unknown";
    }
  };

  render() {
    if (Platform.OS === "web" && !this.props.context.systemUid) {
      if (this.props.path === "/ComponentList") {
        goBack();
      }
      return null;
    }

    const {
      inverterTypes,
      batteryTypes,
      inverterSystems,
      context: { systemUid: uid },
    } = this.props;

    const inverterSystem = inverterSystems[uid];

    const { inverter, battery, pvConnected, pvPhases } = inverterSystem;

    const inverterDetails = inverter.value && inverterTypes[inverter.value];
    const batteryDetails = battery.value && batteryTypes[battery.value];

    const inverterText = inverterDetails
      ? inverterDetails.displayName
      : "Select an inverter...";
    const inverterIllustration = (
      <InverterIllustration uid={inverter.value} details={inverterDetails} />
    );

    const batteryText = batteryDetails
      ? batteryDetails.displayName
      : "Not present";
    const batteryIllustration = (
      <BatteryIllustration batteryDeets={batteryDetails} />
    );

    const solarText = pvConnected.value
      ? pvPhases.value
        ? this.getPhasesDescription(pvPhases.value)
        : "Connected"
      : "Not present";
    const solarIllustration = (
      <SolarIllustration pvConnected={pvConnected.value} />
    );

    const solarEditable =
      inverterDetails && inverterDetails.pvCompatible !== false;
    const batteryEditable =
      inverterDetails && inverterDetails.compatibleBatteryTypes.length !== 0;

    const listItems = [
      {
        ...inverterSystem,
        key: "inverter",
      },
      {
        ...inverterSystem,
        key: "solar",
      },
      {
        ...inverterSystem,
        key: "battery",
      },
    ];

    const renderFn = ({ item: { key } }) => {
      switch (key) {
        case "inverter":
          return (
            <ComponentItem
              title={"Inverter"}
              description={inverterText}
              error={inverter.error}
              image={inverterIllustration}
              onSelect={() => this.handleComponentSelected("inverter")}
            />
          );

        case "solar":
          return (
            <ComponentItem
              title={"Solar"}
              description={solarText}
              error={pvConnected.error || pvPhases.error}
              image={solarIllustration}
              onSelect={
                solarEditable
                  ? () => this.handleComponentSelected("solar")
                  : null
              }
            />
          );

        case "battery":
          return (
            <ComponentItem
              title={"Battery"}
              description={batteryText}
              error={battery.error}
              image={batteryIllustration}
              onSelect={
                batteryEditable
                  ? () => this.handleComponentSelected("battery")
                  : null
              }
            />
          );

        default:
          return null;
      }
    };

    return (
      <View style={{ flex: 1, backgroundColor: "white" }}>
        <WebHeading
          title="Inverter Details"
          left={
            <Text
              style={{ fontWeight: "300", color: RepositColours.blue }}
            ></Text>
          }
          right={
            <Text
              style={{
                marginRight: 20,
                fontSize: Platform.OS === "web" ? 18 : 26,
                fontWeight: "300",
                color: RepositColours.blue,
              }}
              onPress={() => browserHistory.goBack()} // TODO and save...
            >
              Done
            </Text>
          }
        />
        {Platform.OS !== "web" ? (
          <FlatList data={listItems} renderItem={renderFn} />
        ) : (
          <ScrollView>
            {listItems.map((item) => ({ item: item })).map(renderFn)}
          </ScrollView>
        )}
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComponentList);



// WEBPACK FOOTER //
// ./src/containers/kit/ComponentList.js